<template>
  <button class="btn" @click="back()">
    <i class="fas fa-long-arrow-alt-left" />
    {{ $t('pagelayout.back') }}
  </button>
</template>

<script charset="utf-8">
export default {
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
} 
</script>
